'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_totp_Migration$Reader(bytes) {
  this.O9 = null;
  this.l9 = 0;
  this.O9 = bytes;
  this.l9 = 0;
}
export { $c_Lpresto_ui_totp_Migration$Reader as $c_Lpresto_ui_totp_Migration$Reader };
$p = $c_Lpresto_ui_totp_Migration$Reader.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_totp_Migration$Reader;
/** @constructor */
function $h_Lpresto_ui_totp_Migration$Reader() {
}
export { $h_Lpresto_ui_totp_Migration$Reader as $h_Lpresto_ui_totp_Migration$Reader };
$h_Lpresto_ui_totp_Migration$Reader.prototype = $p;
$p.aem = (function() {
  return (this.l9 < this.O9.b.length);
});
$p.Am = (function() {
  var result__lo = 0;
  var result__hi = 0;
  var shift = 0;
  var byte = 0;
  while (true) {
    if ((!this.aem())) {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "protobuf truncado");
    }
    byte = (255 & this.O9.b[this.l9]);
    this.l9 = ((1 + this.l9) | 0);
    var this$2__lo = result__lo;
    var this$2__hi = result__hi;
    var value = (127 & byte);
    var hi = (value >> 31);
    var n = shift;
    var $x_1__lo = (this$2__lo | (((32 & n) === 0) ? (value << n) : 0));
    var $x_1__hi = (this$2__hi | (((32 & n) === 0) ? (((((value >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (hi << n)) : (value << n)));
    result__lo = $x_1__lo;
    result__hi = $x_1__hi;
    shift = ((7 + shift) | 0);
    if (((128 & byte) !== 0)) {
    } else {
      break;
    }
  }
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(result__lo, result__hi);
});
$p.SN = (function() {
  var len = this.Am().e;
  if ((((this.l9 + len) | 0) > this.O9.b.length)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "protobuf truncado");
  }
  var out = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_ArrayOps$().A6(this.O9, this.l9, ((this.l9 + len) | 0));
  this.l9 = ((this.l9 + len) | 0);
  return out;
});
$p.cww = (function(wire) {
  switch (wire) {
    case 0: {
      this.Am();
      return (void 0);
      break;
    }
    case 1: {
      this.l9 = ((8 + this.l9) | 0);
      return (void 0);
      break;
    }
    case 2: {
      this.SN();
      return (void 0);
      break;
    }
    case 5: {
      this.l9 = ((4 + this.l9) | 0);
      return (void 0);
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("wire type " + wire) + " inesperado"));
    }
  }
});
var $d_Lpresto_ui_totp_Migration$Reader = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_totp_Migration$Reader, "presto.ui.totp.Migration$Reader", ({
  a4u: 1
}));
export { $d_Lpresto_ui_totp_Migration$Reader as $d_Lpresto_ui_totp_Migration$Reader };
//# sourceMappingURL=presto.ui.totp.-Migration$-Reader.js.map
